import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import {
  Download,
  Star,
  Users,
  Crown,
  MapPin,
  Calendar,
  Sparkles,
  Shield,
  Compass,
  Monitor,
  MessageCircle,
  Home,
  ChevronRight,
  Check,
  Gift,
  Award,
  Zap,
} from 'lucide-react';

const BROCHURE_PDF_URL = "https://customer-assets.emergentagent.com/job_bb69c14e-e721-4f53-aed8-ca0b062ed855/artifacts/5uslk3vu_Steven%20Yong%20Life%20Mastermind%20Circle.pdf";

const RESORT_IMG = "https://images.unsplash.com/photo-1609171653225-b224655739d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjA1JTIwc3RhciUyMHJlc29ydCUyMHBvb2wlMjB0cm9waWNhbCUyMHN1bnNldHxlbnwwfHx8fDE3NzYyMzg4MTd8MA&ixlib=rb-4.1.0&q=85";
const LANGKAWI_IMG = "https://images.unsplash.com/photo-1647878872662-50d50c74d40e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjByZXNvcnQlMjBsYW5na2F3aSUyMG1hbGF5c2lhJTIwYWVyaWFsJTIwdmlld3xlbnwwfHx8fDE3NzYyMzg3NzJ8MA&ixlib=rb-4.1.0&q=85";

const DIGITAL_TOOLS = [
  { name: "Bazi.live", desc: "Pro Access: All Features + Future Updates + Training", price: "$546/yr" },
  { name: "Lifetunes.live", desc: "Pro Access: All Features + Future Updates + Training", price: "$546/yr" },
  { name: "Fengshuiplotter.live", desc: "Pro Access: All Features + Future Updates + Training", price: "$399/yr" },
  { name: "Onlinetongshu.com", desc: "Pro Access: ARISE Report + Future Updates + Training", price: "$470/yr" },
  { name: "QMDJ.live", desc: "Pro Access: Special Section + Future Updates + Training", price: "$399/yr" },
  { name: "Lifecode.live", desc: "Pro Access: All Features + Future Updates + Training", price: "$399/yr" },
];

const MASTERY_COURSES = [
  {
    name: "Qimen Attunement Mastery",
    desc: "Virtual & Revision (Manifestation)",
    value: "$3,000",
    image: "https://customer-assets.emergentagent.com/job_bb69c14e-e721-4f53-aed8-ca0b062ed855/artifacts/6n4z17fm_Screenshot%202026-04-15%20at%203.53.45%20PM.png",
    tagline: "Align with the 4 Realms to Manifest with Power, Timing & Clarity"
  },
  {
    name: "Bazi Mastery",
    desc: "Virtual & Revision",
    value: "$5,000",
    image: "https://customer-assets.emergentagent.com/job_bb69c14e-e721-4f53-aed8-ca0b062ed855/artifacts/8vwuskzq_Screenshot%202026-04-15%20at%203.53.38%20PM.png",
    tagline: "Strategise, Influence & Win with Bazi"
  },
  {
    name: "Feng Shui Mastery",
    desc: "Virtual & Revision",
    value: "$6,000",
    image: "https://customer-assets.emergentagent.com/job_bb69c14e-e721-4f53-aed8-ca0b062ed855/artifacts/xi6xkp6t_Screenshot%202026-04-15%20at%203.53.28%20PM.png",
    tagline: "Clear, Protect & Align Your Energy for Wealth & Flow"
  },
  {
    name: "Date Selection Mastery",
    desc: "Virtual & Revision",
    value: "$4,000",
    image: "https://customer-assets.emergentagent.com/job_bb69c14e-e721-4f53-aed8-ca0b062ed855/artifacts/sp0cw6bj_Date%20Selection.jpg",
    tagline: "Auspicious Date Selection for Important Events"
  },
  {
    name: "Qimen Forecasting",
    desc: "Virtual & Revision",
    value: "$5,000",
    image: "https://customer-assets.emergentagent.com/job_bb69c14e-e721-4f53-aed8-ca0b062ed855/artifacts/rx225kbd_Screenshot%202026-04-15%20at%203.53.21%20PM.png",
    tagline: "Ancient Strategy for Future Success"
  },
  {
    name: "LifeCode Mastery",
    desc: "Virtual & Revision",
    value: "$5,000",
    image: "https://customer-assets.emergentagent.com/job_bb69c14e-e721-4f53-aed8-ca0b062ed855/artifacts/y1jbf8ud_Screenshot%202026-04-15%20at%204.38.04%20PM.png",
    tagline: "Decode Your Numbers, Design Your Destiny"
  },
];

const MEMBERSHIP_BENEFITS = [
  { icon: Award, name: "ALL LEVEL ACCESS", desc: "Life Decoder University", value: "$10,000", duration: "12 Months" },
  { icon: Shield, name: "CONCIERGE DEDICATED MANAGER", desc: "Personal support throughout", value: "$2,000", duration: "Yes" },
  { icon: Crown, name: "EXCLUSIVE Private Gathering", desc: "Not Open for Sale", value: "Priceless", duration: "1 time" },
  { icon: MessageCircle, name: "DIRECT ACCESS to Steven Yong", desc: "Via WhatsApp", value: "$10,000", duration: "Yes" },
  { icon: Home, name: "FENG SHUI PERSONAL DESK AUDIT", desc: "Office and Home", value: "$2,888", duration: "Yes" },
  { icon: MapPin, name: "4D3N LIFE MASTERMIND RETREAT", desc: "The Westin Langkawi, Dec 2026", value: "$11,888", duration: "1 time" },
];

const BONUSES = [
  { name: "ONE-TIME-PAYMENT DISCOUNT", value: "S$-1,500" },
  { name: "Face Reading Mastery — Virtual & Revision", value: "$4,000" },
  { name: "LifeCode Mastery — Virtual & Revision", value: "$5,000" },
  { name: "Bring 1 Additional Person to Retreat FREE", value: "$4,000" },
];

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const MastermindBrochurePage = () => {
  const navigate = useNavigate();
  const programmeRef = useRef(null);

  const handleDownload = () => {
    window.open(BROCHURE_PDF_URL, '_blank');
  };

  const scrollToProgramme = () => {
    programmeRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      {/* ===== HERO SECTION (Page 1) ===== */}
      <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden pt-16" data-testid="mastermind-hero">
        {/* Background glow */}
        <div className="absolute inset-0 bg-gradient-to-b from-amber-900/10 via-transparent to-transparent" />
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/5 rounded-full blur-[120px]" />

        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
          {/* Presented by */}
          <p className="text-amber-400/70 text-sm tracking-[0.3em] uppercase mb-4 font-medium">Steven Yong Presents</p>

          {/* Main Title */}
          <h1 className="text-5xl sm:text-6xl lg:text-8xl font-black text-white mb-2 tracking-tight leading-none">
            LIFE
          </h1>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-400 mb-6 tracking-wide">
            MASTERMIND CIRCLE
          </h2>

          <p className="text-gray-400 text-base sm:text-lg mb-2 max-w-2xl mx-auto">
            An Elite 1-Year Transformation Programme
          </p>

          {/* Tags */}
          <div className="flex items-center justify-center gap-3 text-xs sm:text-sm text-gray-500 mb-10 flex-wrap">
            <span className="border border-gray-800 rounded-full px-4 py-1.5">1 YEAR</span>
            <span className="border border-gray-800 rounded-full px-4 py-1.5">LIVE + VIRTUAL</span>
            <span className="border border-gray-800 rounded-full px-4 py-1.5">EXCLUSIVE MEMBERSHIP</span>
          </div>

          {/* Total Value */}
          <div className="inline-block mb-12">
            <p className="text-xs text-gray-500 tracking-[0.2em] uppercase mb-1">Total Programme Value</p>
            <p className="text-5xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-amber-400 to-yellow-500">
              S$100,276
            </p>
          </div>

          {/* 3 Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12 max-w-3xl mx-auto">
            <div className="bg-[#111] border border-amber-500/20 rounded-xl p-5 text-center hover:border-amber-500/40 transition-colors">
              <Sparkles className="w-8 h-8 text-amber-400 mx-auto mb-3" />
              <h3 className="text-white font-bold text-sm mb-1">MASTERY TRAINING</h3>
              <p className="text-gray-500 text-xs">5 premium courses included</p>
            </div>
            <div className="bg-[#111] border border-amber-500/20 rounded-xl p-5 text-center hover:border-amber-500/40 transition-colors">
              <Users className="w-8 h-8 text-amber-400 mx-auto mb-3" />
              <h3 className="text-white font-bold text-sm mb-1">PERSONAL MENTORSHIP</h3>
              <p className="text-gray-500 text-xs">Direct access to Steven Yong</p>
            </div>
            <div className="bg-[#111] border border-amber-500/20 rounded-xl p-5 text-center hover:border-amber-500/40 transition-colors">
              <MapPin className="w-8 h-8 text-amber-400 mx-auto mb-3" />
              <h3 className="text-white font-bold text-sm mb-1">ELITE RETREAT</h3>
              <p className="text-gray-500 text-xs">4D3N Langkawi Dec 2026</p>
            </div>
          </div>

          {/* Retreat Highlight */}
          <div className="relative rounded-2xl overflow-hidden max-w-3xl mx-auto mb-12">
            <img src={RESORT_IMG} alt="Luxury Resort" className="w-full h-48 sm:h-64 object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-left">
              <p className="text-amber-400 text-xs tracking-[0.2em] uppercase mb-1">4D3N LIFE MASTERMIND RETREAT</p>
              <p className="text-white font-bold text-lg sm:text-xl">The Westin Langkawi Resort & Spa</p>
              <div className="flex flex-wrap items-center gap-3 mt-2 text-xs text-gray-300">
                <span className="flex items-center gap-1"><Calendar className="w-3 h-3 text-amber-400" /> December 2026</span>
                <span className="flex items-center gap-1"><Star className="w-3 h-3 text-amber-400" /> Value S$11,888</span>
                <span className="flex items-center gap-1"><Gift className="w-3 h-3 text-amber-400" /> Bring 1 Guest FREE</span>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              onClick={scrollToProgramme}
              className="bg-amber-500 hover:bg-amber-400 text-black font-bold px-8 py-3 text-base"
              data-testid="view-programme-btn"
            >
              View Full Programme
              <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
            <Button
              variant="outline"
              onClick={handleDownload}
              className="border-amber-500/30 text-amber-400 hover:bg-amber-500/10 px-8 py-3 text-base"
              data-testid="download-brochure-btn"
            >
              <Download className="w-4 h-4 mr-2" />
              Download Brochure
            </Button>
          </div>

          {/* Footer tags */}
          <div className="mt-16 flex items-center justify-center gap-4 text-xs text-gray-600">
            <span>EXCLUSIVE</span>
            <span className="w-1 h-1 rounded-full bg-amber-500" />
            <span>LIMITED SEATS</span>
            <span className="w-1 h-1 rounded-full bg-amber-500" />
            <span>APPLY NOW</span>
          </div>
        </div>
      </section>

      {/* ===== FULL PROGRAMME SECTION (Page 2) ===== */}
      <section ref={programmeRef} className="py-20 px-4" data-testid="mastermind-programme">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-amber-400/70 text-xs tracking-[0.3em] uppercase mb-3">Full Programme</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-3">LIFE MASTERMIND CIRCLE</h2>
            <div className="flex items-center justify-center gap-3 text-sm text-gray-400">
              <span>1 YEAR</span>
              <span className="w-1 h-1 rounded-full bg-amber-500" />
              <span className="text-amber-400 font-bold">S$100,276 IN TOTAL VALUE</span>
            </div>
          </div>

          {/* Mastermind Circle - 1 Year */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-8 bg-amber-500 rounded-full" />
              <h3 className="text-xl font-bold text-white">LIFE MASTERMIND CIRCLE — 1 YEAR</h3>
            </div>
            <div className="space-y-3">
              {[
                { label: "MEETINGS", detail: "2 LIVE and 2 Virtual", qty: "4 times", value: "" },
                { label: "PERSONAL 1-ON-1 SESSION with Steven Yong", detail: "30 mins each — Virtual", qty: "2 times", value: "$4,000" },
                { label: "12 MONTHS Hot Seat Coaching with Steven Yong", detail: "2 Hours/Month", qty: "12 Months", value: "$10,000" },
              ].map((item, i) => (
                <div key={i} className="bg-[#111] border border-gray-800/60 rounded-xl p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                  <div className="flex-1">
                    <p className="text-white font-semibold text-sm">{item.label}</p>
                    <p className="text-gray-500 text-xs">{item.detail}</p>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="text-gray-400 text-xs">{item.qty}</span>
                    {item.value && <span className="text-amber-400 font-bold text-sm">{item.value}</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Digital Tools */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-8 bg-amber-500 rounded-full" />
              <div>
                <h3 className="text-xl font-bold text-white">DECISION SYSTEM + SPECIALISED TRAINING</h3>
                <p className="text-gray-500 text-xs">12 Months — Pro Features</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {DIGITAL_TOOLS.map((tool, i) => (
                <div key={i} className="bg-[#111] border border-gray-800/60 rounded-xl p-4 flex items-center justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <Monitor className="w-4 h-4 text-amber-400" />
                      <p className="text-white font-semibold text-sm">{tool.name}</p>
                    </div>
                    <p className="text-gray-500 text-xs pl-6">{tool.desc}</p>
                  </div>
                  <span className="text-amber-400 font-bold text-sm shrink-0">{tool.price}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Life Forecasting Mastery */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-8 bg-amber-500 rounded-full" />
              <div>
                <h3 className="text-xl font-bold text-white">LIFE FORECASTING MASTERY</h3>
                <p className="text-gray-500 text-xs">Premium Content</p>
              </div>
            </div>
            {/* Top row: 3 cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
              {MASTERY_COURSES.slice(0, 3).map((course, i) => (
                <div key={i} className="group bg-[#111] border border-gray-800/60 rounded-xl overflow-hidden hover:border-amber-500/30 transition-all">
                  <div className="relative aspect-square overflow-hidden bg-[#0a0a0a]">
                    <img src={course.image} alt={course.name} className="w-full h-full object-contain group-hover:scale-[1.1] transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                    <div className="absolute top-3 right-3 bg-amber-500/90 text-black text-xs font-bold px-2.5 py-1 rounded-full">
                      {course.value}
                    </div>
                  </div>
                  <div className="p-4">
                    <h4 className="text-white font-bold text-sm mb-1">{course.name}</h4>
                    <p className="text-gray-500 text-xs mb-2">{course.desc}</p>
                    <p className="text-amber-400/70 text-xs italic">{course.tagline}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* Bottom row: 3 cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {MASTERY_COURSES.slice(3).map((course, i) => (
                <div key={i} className="group bg-[#111] border border-gray-800/60 rounded-xl overflow-hidden hover:border-amber-500/30 transition-all">
                  <div className="relative aspect-square overflow-hidden bg-[#0a0a0a]">
                    <img src={course.image} alt={course.name} className="w-full h-full object-contain group-hover:scale-[1.1] transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                    <div className="absolute top-3 right-3 bg-amber-500/90 text-black text-xs font-bold px-2.5 py-1 rounded-full">
                      {course.value}
                    </div>
                  </div>
                  <div className="p-4">
                    <h4 className="text-white font-bold text-sm mb-1">{course.name}</h4>
                    <p className="text-gray-500 text-xs mb-2">{course.desc}</p>
                    <p className="text-amber-400/70 text-xs italic">{course.tagline}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Exclusive Membership Benefits */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-8 bg-amber-500 rounded-full" />
              <h3 className="text-xl font-bold text-white">EXCLUSIVE MEMBERSHIP BENEFITS</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {MEMBERSHIP_BENEFITS.map((benefit, i) => {
                const Icon = benefit.icon;
                return (
                  <div key={i} className="bg-[#111] border border-gray-800/60 rounded-xl p-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center shrink-0">
                        <Icon className="w-5 h-5 text-amber-400" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-white font-semibold text-sm">{benefit.name}</p>
                        <p className="text-gray-500 text-xs">{benefit.desc}</p>
                        <div className="flex items-center gap-3 mt-2">
                          <span className="text-amber-400 font-bold text-sm">{benefit.value}</span>
                          <span className="text-gray-600 text-xs">{benefit.duration}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Full Payment Bonuses */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-8 bg-emerald-500 rounded-full" />
              <div>
                <h3 className="text-xl font-bold text-white">FULL PAYMENT BONUSES</h3>
                <p className="text-gray-500 text-xs">One-Time Payment Only</p>
              </div>
            </div>
            <div className="space-y-3">
              {BONUSES.map((bonus, i) => (
                <div key={i} className="bg-emerald-500/5 border border-emerald-500/20 rounded-xl p-4 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <Gift className="w-5 h-5 text-emerald-400" />
                    <p className="text-white font-semibold text-sm">{bonus.name}</p>
                  </div>
                  <span className={`font-bold text-sm ${bonus.value.includes('-') ? 'text-red-400' : 'text-emerald-400'}`}>{bonus.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Total Value Banner */}
          <div className="bg-gradient-to-r from-amber-500/10 via-amber-500/5 to-amber-500/10 border border-amber-500/30 rounded-2xl p-8 text-center">
            <p className="text-gray-400 text-sm tracking-[0.2em] uppercase mb-2">Total Programme Value</p>
            <p className="text-5xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-amber-400 to-yellow-500">
              S$100,276
            </p>
          </div>
        </div>
      </section>

      {/* ===== RETREAT SECTION (Page 3) ===== */}
      <section className="py-20 px-4" data-testid="mastermind-retreat">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-amber-400/70 text-xs tracking-[0.3em] uppercase mb-3">The Ultimate Experience</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-white">LIFE MASTERMIND RETREAT</h2>
          </div>

          {/* Retreat Card */}
          <div className="relative rounded-2xl overflow-hidden mb-16">
            <img src={LANGKAWI_IMG} alt="Langkawi" className="w-full h-64 sm:h-96 object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-10">
              <p className="text-amber-400 text-xs tracking-[0.2em] uppercase mb-2">4D3N LIFE MASTERMIND RETREAT</p>
              <p className="text-white font-bold text-2xl sm:text-3xl mb-4">The Westin Langkawi Resort & Spa</p>
              <p className="text-gray-400 text-sm mb-6">December 2026</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg">
                {[
                  "Value S$11,888 per person",
                  "Bring 1 guest FREE — Spouse, Business Partner or Family Member",
                  "Just arrange your own flight & accommodation",
                  "Immersive mastermind sessions in a luxury 5-star resort",
                  "Exclusive networking with elite circle members",
                ].map((point, i) => (
                  <div key={i} className="flex items-start gap-2">
                    <Check className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />
                    <p className="text-gray-300 text-sm">{point}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Why Section */}
          <div className="mb-16">
            <div className="text-center mb-10">
              <h3 className="text-2xl sm:text-3xl font-bold text-white">
                WHY THE LIFE <span className="text-amber-400">MASTERMIND</span> CIRCLE?
              </h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                {
                  icon: Compass,
                  title: "Master the Ancient Sciences",
                  desc: "Bazi, Feng Shui, Qimen Dunjia & Date Selection decoded for modern success."
                },
                {
                  icon: Monitor,
                  title: "Pro-Level Digital Tools",
                  desc: "Exclusive 12-month pro access to 6 powerful life analysis platforms."
                },
                {
                  icon: Users,
                  title: "Personalised Guidance",
                  desc: "Hot seat coaching + 1-on-1 sessions directly with Steven Yong."
                },
                {
                  icon: Crown,
                  title: "Elite Community",
                  desc: "Surround yourself with high-achieving individuals on the same journey."
                },
              ].map((item, i) => {
                const Icon = item.icon;
                return (
                  <div key={i} className="bg-[#111] border border-gray-800/60 rounded-xl p-6 hover:border-amber-500/30 transition-colors">
                    <div className="w-12 h-12 rounded-xl bg-amber-500/10 flex items-center justify-center mb-4">
                      <Icon className="w-6 h-6 text-amber-400" />
                    </div>
                    <h4 className="text-white font-bold mb-2">{item.title}</h4>
                    <p className="text-gray-400 text-sm">{item.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Final CTA */}
          <div className="bg-gradient-to-br from-amber-500/10 via-[#111] to-amber-500/5 border border-amber-500/20 rounded-2xl p-8 sm:p-12 text-center" data-testid="mastermind-cta">
            <Zap className="w-10 h-10 text-amber-400 mx-auto mb-4" />
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
              SECURE YOUR SEAT
            </h3>
            <p className="text-amber-400 text-sm tracking-[0.15em] uppercase mb-6">Limited Availability</p>
            <p className="text-gray-400 text-sm max-w-md mx-auto mb-8">
              Apply now at stevenyong.com or contact us directly
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                onClick={() => navigate('/contact')}
                className="bg-amber-500 hover:bg-amber-400 text-black font-bold px-8 py-3 text-base"
                data-testid="apply-now-btn"
              >
                Apply Now
                <ChevronRight className="w-4 h-4 ml-1" />
              </Button>
              <Button
                variant="outline"
                onClick={handleDownload}
                className="border-amber-500/30 text-amber-400 hover:bg-amber-500/10 px-8 py-3 text-base"
                data-testid="download-brochure-btn-bottom"
              >
                <Download className="w-4 h-4 mr-2" />
                Download Brochure (PDF)
              </Button>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-12 text-center">
            <div className="flex items-center justify-center gap-3 text-xs text-gray-600">
              <span>Steven Yong</span>
              <span className="w-1 h-1 rounded-full bg-amber-500" />
              <span>Life Mastermind Circle</span>
              <span className="w-1 h-1 rounded-full bg-amber-500" />
              <span>1 Year Programme</span>
              <span className="w-1 h-1 rounded-full bg-amber-500" />
              <span className="text-amber-400">Total Value S$100,276</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MastermindBrochurePage;
